module.exports = __webpack_public_path__ + "static/media/weight LossActive.8921f002.svg";